<template>
  <!-- <a :href="resultLink" class="btn btn-sm btn-outline-info" target="_blank">View result</a> -->
  <span>
    <a @click.prevent="getResultLink()" style="cursor: pointer;" class="btn btn-sm btn-outline-info">View result</a>
  </span>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ViewStudentResult',

  props: {
    user: {
      matric: String
    }
  },

  methods: {
    getResultLink() {
      axios.get(`/result-link/non-student/${this.user.matric}`).then(res => {
        if (res.data.status == 'success') {
          window.open(res.data.resultLink, '_blank')
        }
      })
    }
  }
}
</script>

<style scoped></style>
